export class Address{
    _id?: string;
    name?: string;
    personTo?: string;
    line1?: string;
    line2?: string;
    postcode?: string;
    region?: string;
    country?: string;
    createdAt?: Date;
    updatedAt?: Date;  
}
